/**
 * Drift Detection API Service
 */

import { apiClient } from "./api";
import type { AgentBaseline, DriftEvent, DriftEventStatus, DriftRule, DriftRuleUpdate } from "@/types/drift";

const API_PREFIX = "/api/v1/drift";

export async function getAgentBaseline(agentId: number): Promise<AgentBaseline> {
  return apiClient.get<AgentBaseline>(`${API_PREFIX}/agents/${agentId}/baseline`);
}

export async function getAgentDriftEvents(
  agentId: number,
  params?: { severity?: string; drift_type?: string; limit?: number; offset?: number }
): Promise<DriftEvent[]> {
  const searchParams = new URLSearchParams();
  if (params?.severity) searchParams.append("severity", params.severity);
  if (params?.drift_type) searchParams.append("drift_type", params.drift_type);
  if (params?.limit) searchParams.append("limit", params.limit.toString());
  if (params?.offset) searchParams.append("offset", params.offset.toString());
  const qs = searchParams.toString();
  return apiClient.get<DriftEvent[]>(
    `${API_PREFIX}/agents/${agentId}/drift-events${qs ? `?${qs}` : ""}`
  );
}

export async function updateDriftEventStatus(
  eventId: number,
  status: DriftEventStatus
): Promise<DriftEvent> {
  return apiClient.patch<DriftEvent>(`${API_PREFIX}/events/${eventId}`, { status });
}

export async function recomputeBaseline(
  agentId: number
): Promise<AgentBaseline> {
  return apiClient.post<AgentBaseline>(
    `${API_PREFIX}/agents/${agentId}/baseline/recompute`
  );
}

export async function getAgentRules(agentId: number): Promise<DriftRule[]> {
  return apiClient.get<DriftRule[]>(`${API_PREFIX}/agents/${agentId}/rules`);
}

export async function updateAgentRule(
  agentId: number,
  ruleId: string,
  update: DriftRuleUpdate
): Promise<DriftRule> {
  return apiClient.patch<DriftRule>(
    `${API_PREFIX}/agents/${agentId}/rules/${ruleId}`,
    update
  );
}
